import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const ServiceDetailsPageContent = lazy(() => import("./ServiceDetailsPageContent"));

function ServiceDetailsPageInternal() {
    return (
        <DefaultPage>
            <ServiceDetailsPageContent />
        </DefaultPage>
    );
}

export const ServiceDetailsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    ServiceDetailsPageInternal
);
